import {
    GET_USERS,
    SET_REPORT_TYPE,
    GET_VEHICLE_LIST,
    GET_REPORT_TITLES,
    SET_DATE_FROM,
    SET_DATE_TO,
    GET_TOTAL_USER_REPORTS,
    SET_EXCEL_REPORT_TYPE,
    GET_TOTAL_JOB_PACK_REPORTS,
    GET_EXCEL_REPORT_TYPE_LABELS,
    GET_EXCEL_DOCUMENT_BUILDING,
    GET_EXCEL_DOCUMENT_FINISHED
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    users: false,
    report_type: "general",
    vehicleList: false,
    reportTitles: false,
    dateFrom: false,
    dateTo: false,
    totalReports: false,
    excelReportType: false,
    totalJobPackReports: false,
    reportExcelLabels: false,
    buildingExcelDoc: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_DATE_FROM: {
            return { ...state, dateFrom: action.payload };
        }
        case SET_DATE_TO: {
            return { ...state, dateTo: action.payload };
        }
        case GET_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case GET_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case SET_REPORT_TYPE: {
            return { ...state, report_type: action.payload };
        }
        case GET_VEHICLE_LIST.REQUEST: {
            return { ...state, requesting: true, vehicleList: false };
        }
        case GET_VEHICLE_LIST.FAIL: {
            return { ...state, requesting: false, vehicleList: false };
        }
        case GET_VEHICLE_LIST.SUCCESS: {
            return {
                ...state,
                requesting: false,
                vehicleList: action.payload
            };
        }
        case GET_REPORT_TITLES.REQUEST: {
            return { ...state, requesting: true, reportTitles: false };
        }
        case GET_REPORT_TITLES.SUCCESS: {
            return {
                ...state,
                requesting: false,
                reportTitles: action.payload
            };
        }
        case GET_REPORT_TITLES.FAIL: {
            return { ...state, requesting: false, reportTitles: false };
        }
        case GET_TOTAL_USER_REPORTS.REQUEST: {
            return { ...state, requesting: true };
        }
        case GET_TOTAL_USER_REPORTS.FAIL: {
            return { ...state, requesting: false };
        }
        case GET_TOTAL_USER_REPORTS.SUCCESS: {
            return { ...state, requesting: false, totalReports: action.payload };
        }
        case GET_TOTAL_JOB_PACK_REPORTS.REQUEST: {
            return { ...state, requesting: true };
        }
        case GET_TOTAL_JOB_PACK_REPORTS.FAIL: {
            return { ...state, requesting: false };
        }
        case GET_TOTAL_JOB_PACK_REPORTS.SUCCESS: {
            return { ...state, requesting: false, totalJobPackReports: action.payload };
        }
        case SET_EXCEL_REPORT_TYPE: {
            return { ...state, excelReportType: action.payload };
        }
        case GET_EXCEL_REPORT_TYPE_LABELS.REQUEST: {
            return { ...state, requesting: true };
        }
        case GET_EXCEL_REPORT_TYPE_LABELS.FAIL: {
            return { ...state, requesting: false };
        }
        case GET_EXCEL_REPORT_TYPE_LABELS.SUCCESS: {
            return { ...state, requesting: false, reportExcelLabels: action.payload };
        }
        case GET_EXCEL_DOCUMENT_BUILDING: {
            return { ...state, buildingExcelDoc: true };
        }
        case GET_EXCEL_DOCUMENT_FINISHED: {
            return { ...state, buildingExcelDoc: false };
        }
        default: {
            return state;
        }
    }
};
